import ShoppingBasket from '../pages/shopping-basket/ShoppingBasket';
import CashPayment from '../pages/shopping-basket/cash-payment/CashPayment';
import TransactionReport from '../pages/shopping-basket/cash-payment/TransactionReport';
import CardToCardPage from '../pages/shopping-basket/cash-payment/card-to-card-pay/CardToCardPage';
import CheckOrder from '../pages/shopping-basket/check-order/CheckOrder';
import CompleteInfo from '../pages/shopping-basket/complete-info/CompleteInfo';
import type {AppRouteConfig} from './route.types';

export const shoppingBasketRoutes: AppRouteConfig[] = [
  {path: 'shopping-basket', element: ShoppingBasket},
  {path: 'complete-info', element: CompleteInfo},
  {path: 'check-order/:orderGuid', element: CheckOrder},
  {
    path: 'cash-payment',
    children: [
      {path: ':orderGuid/:storeOrderGuid?', element: CashPayment},
      {
        path: 'card-to-card-pay/:orderGuid/:storeOrderGuid?',
        element: CardToCardPage,
      },
    ],
  },
  {path: 'transaction-report', element: TransactionReport},
];
